import { FC } from "react";
import { IconPropsType } from ".";

export const Statistics: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2H4C3.44771 2 3 2.44772 3 3V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V3C21 2.44772 20.5523 2 20 2ZM4 1C2.89543 1 2 1.89543 2 3V21C2 22.1046 2.89543 23 4 23H20C21.1046 23 22 22.1046 22 21V3C22 1.89543 21.1046 1 20 1H4Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 6.5H6V5.5H18V6.5ZM18 10.5H6V9.5H18V10.5ZM18 14.5H6V13.5H18V14.5ZM12.5 18.5H6V17.5H12.5V18.5Z"
        fill={props.color}
      />
    </svg>
  );
};
